<tam-dialog class="container" tid="save_workflow_dialog" [opened]="dialogOpened" (keydown.esc)="onCancelClick()">
    <ng-template #title>
        <span class="dialog-title">{{dialogTitle}}</span>
        <smart-icon class="dark dialog-close" name="close" (click)="onCancelClick()">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <form [formGroup]="contentForm">
            <div class="tam-form-field" [ngClass]="{'has-error': name.invalid}">
                <div class="improt-config-file">
                    <a (click)="onImportConfigFileClick($event)">Import From Configuration File</a>
                    <input type="file" accept="application/json" id="file-selector" class="file-selector"
                        (change)="onConfigFileInput($event)">
                </div>
                <div class=" tam-form-label">
                    <span>Name&nbsp;<span class="required-field">*</span></span>
                </div>
                <input type="text" class="tam-textbox" formControlName="name">
                <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                    {{'general.workflow_name_exceed_maximum' | stringLiterals: '128'}}
                </div>
                <div class="tam-form-help" *ngIf="name.invalid && name.errors['duplicated']">
                    {{'general.name_already_exist' | stringLiterals}}
                </div>
            </div>
            <div class="tam-form-field" [ngClass]="{'has-error': description.invalid}">
                <div class="tam-form-label">
                    <span>Description</span>
                </div>
                <textarea class="tam-textbox textarea" formControlName="description"></textarea>
                <div class="tam-form-help" *ngIf="description.invalid && description.errors['maxlength']">
                    Workflow description exceeds the maximum of 256 characters allowed.
                </div>
            </div>
        </form>
        <div class="access-div">
            <span>Public</span>
            <kendo-switch onLabel="Yes" offLabel="No" [(ngModel)]="config.isPublic" (valueChange)="onPublicChange()">
            </kendo-switch>
            <div class="list-box" [hidden]="config.isPublic">
                <tam-dual-list #dualList [config]="dualListConfig" [itemRender]="accessListItem">
                    <ng-template #accessListItem let-item>
                        <div class="access-item">
                            <span [style.font-weight]="item.data.type === 'team' ? 'bold' : 'normal'">
                                {{item.data.name}}
                            </span>
                        </div>
                    </ng-template>
                </tam-dual-list>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button class="footer-button footer-research-button" tam-button [tamType]="'tertiary'" [tamSize]="'normal'"
            (click)="onCancelClick()">Cancel</button>
        <button class="footer-button footer-research-button" tam-button [tamType]="'primary'" [tamSize]="'normal'"
            [tamLoading]="isSaving" [disabled]="saveBtnStatus" (click)="onSaveClick()">Save</button>
    </ng-template>
</tam-dialog>